import { __awaiter, __decorate, __param } from 'tslib';
import { Inject, Injectable, Optional, SkipSelf, NgModule } from '@angular/core';
import { SpeNOpenAccountProxy, ConfigService, SpeNDeviceProxy, SpeNAccessQrCodeProxy, UiPxLoginModule, SpeExtOauthProxy } from '@wlp/ui-px-login';
import { BaseService, ErrorMessageService, UiBsUtilModule } from '@wlp/ui-bs-util';
import { Storage, IonicStorageModule } from '@ionic/storage';
import { KeycloakService } from 'keycloak-angular';
export * from 'keycloak-angular';
import { APP_PARAMETER } from '@wlp/ui-bs-parameter';
import { IonicModule } from '@ionic/angular';

let UserInfoService = class UserInfoService extends BaseService {
    constructor(speNOpenAccountProxy, configService, storage, keycloakService, param) {
        super(storage, configService);
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.configService = configService;
        this.storage = storage;
        this.keycloakService = keycloakService;
        this.param = param;
    }
    getInfoProfile() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let userProfile;
                const userDetails = this.keycloakService.loadUserProfile();
                const token = this.keycloakService.getKeycloakInstance().tokenParsed;
                return userDetails.then((user) => {
                    return (userProfile = {
                        uuidAccount: this.captureValue(user.attributes.uuidAccount),
                        uuidWhiteLabel: this.captureValue(user.attributes.uuidWl),
                        nameComplete: user.firstName + ' ' + user.lastName,
                        nameFirst: user.firstName,
                        nameInitials: this.captureValue(user.attributes.nameInitials),
                        email: user.email,
                        codeBank: this.captureValue(user.attributes.codeBank),
                        nameBank: this.captureValue(user.attributes.nameBank),
                        agencyBank: this.captureValue(user.attributes.agencyBank),
                        numberAccountBank: this.captureValue(user.attributes.numberAccountBank),
                        isEC: this.captureValue(user.attributes.isEC),
                        extraAttributes: this.preparerExtraAttribute(user),
                        userId: token ? token.sub : user.id,
                    });
                });
            }
            catch (e) {
                console.error('Failed to load user details', e);
            }
        });
    }
    captureValue(value) {
        if (value && typeof value === 'object' && value.constructor === Array) {
            return value[0];
        }
        else {
            return value;
        }
    }
    preparerExtraAttribute(keycloakProfile) {
        const extras = new Array();
        if (keycloakProfile.attributes) {
            const keyNames = Object.keys(keycloakProfile.attributes);
            for (const attribute of keyNames) {
                if (attribute !== 'uuidAccount' &&
                    attribute !== 'uuidWhiteLabel' &&
                    attribute !== 'nameInitials' &&
                    attribute !== 'codeBank' &&
                    attribute !== 'nameBank' &&
                    attribute !== 'agencyBank' &&
                    attribute !== 'numberAccountBank' &&
                    attribute !== 'isEC' &&
                    attribute !== 'uuidWl') {
                    extras.push({ key: attribute, value: this.captureValue(keycloakProfile.attributes[attribute]) });
                }
            }
            return extras;
        }
        return extras;
    }
    getRoles() {
        return this.keycloakService.getUserRoles(true);
    }
    isUserInRole(role, resource = null) {
        return this.keycloakService.isUserInRole(role, resource);
    }
    onLogout(redirectUri) {
        this.keycloakService.logout(redirectUri);
    }
    getApplicationAccess() {
        const roles = this.getRoles();
        const applicationBase = this.param.config.wlThemeParameterization.wlTheme.application;
        const applicationAccess = [];
        if (applicationBase) {
            for (const role of roles) {
                const appInclude = applicationBase.filter((app) => {
                    const hasPermission = app.roles.find((appRole) => {
                        if (String(appRole).includes('mentor') && String(role).includes('mentor')) {
                            return true;
                        }
                        if (String(appRole).includes(role)) {
                            return true;
                        }
                        return false;
                    });
                    if (hasPermission) {
                        return true;
                    }
                    return false;
                });
                if (appInclude) {
                    appInclude.forEach((include) => {
                        applicationAccess.push(include);
                    });
                }
            }
        }
        return applicationAccess;
    }
};
UserInfoService.ctorParameters = () => [
    { type: SpeNOpenAccountProxy },
    { type: ConfigService },
    { type: Storage },
    { type: KeycloakService },
    { type: undefined, decorators: [{ type: Inject, args: [APP_PARAMETER,] }] }
];
UserInfoService = __decorate([
    Injectable(),
    __param(4, Inject(APP_PARAMETER))
], UserInfoService);

let DeviceInfoService = class DeviceInfoService extends BaseService {
    constructor(speNDevice, configService, storage, errorMessageService, param) {
        super(storage, configService);
        this.speNDevice = speNDevice;
        this.configService = configService;
        this.storage = storage;
        this.errorMessageService = errorMessageService;
        this.param = param;
    }
    sendDeviceInfo(data, uuidAccountPayment) {
        return this.speNDevice.deviceInfo(data, uuidAccountPayment);
    }
    getError(error) {
        this.errorMessageService.getError(error);
    }
    checkOtp(data) {
        return this.speNDevice.checkOtp(data);
    }
    bioAuth(device, headerValue) {
        return this.speNDevice.bioAuth(device, headerValue);
    }
    bioEnroll(device) {
        return this.speNDevice.bioEnroll(device);
    }
};
DeviceInfoService.ctorParameters = () => [
    { type: SpeNDeviceProxy },
    { type: ConfigService },
    { type: Storage },
    { type: ErrorMessageService },
    { type: undefined, decorators: [{ type: Inject, args: [APP_PARAMETER,] }] }
];
DeviceInfoService = __decorate([
    Injectable(),
    __param(4, Inject(APP_PARAMETER))
], DeviceInfoService);

let QrCodeService = class QrCodeService extends BaseService {
    constructor(speNQrCode, configService, storage, errorMessageService, param) {
        super(storage, configService);
        this.speNQrCode = speNQrCode;
        this.configService = configService;
        this.storage = storage;
        this.errorMessageService = errorMessageService;
        this.param = param;
    }
    generateQrCode(uuidWhiteLabel, uuidAccountPayment, location) {
        return this.speNQrCode.generateQrCode(uuidWhiteLabel, uuidAccountPayment, location);
    }
    validateAccess(data) {
        return this.speNQrCode.validateAccess(data);
    }
    checkAccessStatus(data) {
        return this.speNQrCode.checkAccessStatus(data);
    }
    getError(error) {
        this.errorMessageService.getError(error);
    }
};
QrCodeService.ctorParameters = () => [
    { type: SpeNAccessQrCodeProxy },
    { type: ConfigService },
    { type: Storage },
    { type: ErrorMessageService },
    { type: undefined, decorators: [{ type: Inject, args: [APP_PARAMETER,] }] }
];
QrCodeService = __decorate([
    Injectable(),
    __param(4, Inject(APP_PARAMETER))
], QrCodeService);

var UiBsLoginModule_1;
let UiBsLoginModule = UiBsLoginModule_1 = class UiBsLoginModule {
    constructor(parentModule) {
        // ...
    }
    static forRoot(config) {
        return {
            ngModule: UiBsLoginModule_1,
            providers: [{ provide: APP_PARAMETER, useValue: config }],
        };
    }
};
UiBsLoginModule.ctorParameters = () => [
    { type: UiBsLoginModule, decorators: [{ type: Optional }, { type: SkipSelf }] }
];
UiBsLoginModule = UiBsLoginModule_1 = __decorate([
    NgModule({
        declarations: [],
        imports: [
            IonicModule,
            IonicStorageModule.forRoot({
                driverOrder: ['indexeddb', 'sqlite', 'websql'],
            }),
            UiPxLoginModule,
            UiBsUtilModule,
        ],
        providers: [UserInfoService, DeviceInfoService, QrCodeService],
    }),
    __param(0, Optional()), __param(0, SkipSelf())
], UiBsLoginModule);

let LoginService = class LoginService extends BaseService {
    constructor(speExtOauthProxy, configService, storage, param) {
        super(storage, configService);
        this.speExtOauthProxy = speExtOauthProxy;
        this.configService = configService;
        this.storage = storage;
        this.param = param;
    }
    authenticate(requestToken) {
        return this.speExtOauthProxy.accessToken(requestToken).toPromise();
    }
};
LoginService.ctorParameters = () => [
    { type: SpeExtOauthProxy },
    { type: ConfigService },
    { type: Storage },
    { type: undefined, decorators: [{ type: Inject, args: [APP_PARAMETER,] }] }
];
LoginService = __decorate([
    Injectable(),
    __param(3, Inject(APP_PARAMETER))
], LoginService);

/*
 * Public API Surface of ui-bs-login
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DeviceInfoService, LoginService, QrCodeService, UiBsLoginModule, UserInfoService };
//# sourceMappingURL=wlp-ui-bs-login.js.map
